import { useContext } from 'react';

import { MarkdownContextInstance } from './MarkdownContextProvider';

const useMarkdownContext = () => {
  return useContext(MarkdownContextInstance);
};

export { useMarkdownContext };
